import { ApiConnectorInstance } from '@/Singletons';

export default class ClientApi {
    getHttpClient(includeToken: boolean = true) {
        return ApiConnectorInstance.getHttpClient('admin', includeToken);
    }

    getLocalHttpClient(includeToken: boolean = true) {
        return ApiConnectorInstance.getHttpClient('local', includeToken);
    }
}
